import {
    useEffect,
    useState,
} from 'react';

import api from '../../api/api';

import AdminLayout from './Components/AdminLayout';
import TimeModal from "./Components/TimeModal";

export default function AdminTime()
{
    const [times, setTimes] =
        useState<any[]>([]);

    const [modalOpen, setModalOpen] =
        useState(false);

    const [selectedTime, setSelectedTime] =
        useState<any>(null);

    const loadTimes = async () => {

        const response =
            await api.get(
                '/times'
            );

        setTimes(
            response.data
        );
    };

    useEffect(() => {

        loadTimes();

    }, []);

    const handleSave = async (
        data: FormData
    ) => {

        if (
            selectedTime
        ) {

            await api.post(

                `/times/${selectedTime.id}?_method=PUT`,

                data,

                {
                    headers: {
                        'Content-Type':
                            'multipart/form-data',
                    },
                }

            );

        } else {

            await api.post(

                '/times',

                data,

                {
                    headers: {
                        'Content-Type':
                            'multipart/form-data',
                    },
                }

            );
        }

        setModalOpen(
            false
        );

        setSelectedTime(
            null
        );

        loadTimes();
    };

    const handleDelete = async (
        id: number
    ) => {

        if (
            !window.confirm(
                'Delete this time?'
            )
        ) {
            return;
        }

        await api.delete(
            `/times/${id}`
        );

        loadTimes();
    };

    const moveTimeUp = async (
        index: number
    ) => {

        if (
            index <= 0
        ) {
            return;
        }

        const updated =
            [...times];

        [
            updated[index - 1],
            updated[index]
        ] = [
            updated[index],
            updated[index - 1]
        ];

        setTimes(
            updated
        );

        await api.post(
            '/times/reorder',
            {
                times:
                    updated.map(
                        (
                            time,
                            position
                        ) => ({
                            id:
                            time.id,

                            display_order:
                                position + 1,
                        })
                    ),
            }
        );

        loadTimes();
    };

    const moveTimeDown = async (
        index: number
    ) => {

        if (
            index >=
            times.length - 1
        ) {
            return;
        }

        const updated =
            [...times];

        [
            updated[index],
            updated[index + 1]
        ] = [
            updated[index + 1],
            updated[index]
        ];

        setTimes(
            updated
        );

        await api.post(
            '/times/reorder',
            {
                times:
                    updated.map(
                        (
                            time,
                            position
                        ) => ({
                            id:
                            time.id,

                            display_order:
                                position + 1,
                        })
                    ),
            }
        );

        loadTimes();
    };

    return (

        <AdminLayout>

            <div className="page-header">

                <h1>
                    Times
                </h1>

                <button
                    className="action-btn"
                    onClick={() => {

                        setSelectedTime(
                            null
                        );

                        setModalOpen(
                            true
                        );

                    }}
                >
                    Add Time
                </button>

            </div>

            <table className="users-table">

                <thead>

                <tr>

                    <th>
                        Name
                    </th>

                    <th>
                        Active
                    </th>

                    <th>
                        Actions
                    </th>

                </tr>

                </thead>

                <tbody>

                {times.map(
                    (
                        time,
                        index
                    ) => (

                        <tr
                            key={
                                time.id
                            }
                        >

                            <td>
                                {
                                    time.name
                                }
                            </td>

                            <td>
                                {
                                    time.is_active
                                        ? 'Yes'
                                        : 'No'
                                }
                            </td>

                            <td>

                                <div className="actions">

                                    <button
                                        className="edit-btn"
                                        onClick={() =>
                                            moveTimeUp(
                                                index
                                            )
                                        }
                                    >
                                        ▲
                                    </button>

                                    <button
                                        className="edit-btn"
                                        onClick={() =>
                                            moveTimeDown(
                                                index
                                            )
                                        }
                                    >
                                        ▼
                                    </button>

                                    <button
                                        className="edit-btn"
                                        onClick={() => {

                                            setSelectedTime(
                                                time
                                            );

                                            setModalOpen(
                                                true
                                            );

                                        }}
                                    >
                                        Edit
                                    </button>

                                    <button
                                        className="delete-btn"
                                        onClick={() =>
                                            handleDelete(
                                                time.id
                                            )
                                        }
                                    >
                                        Delete
                                    </button>

                                </div>

                            </td>

                        </tr>

                    )
                )}

                </tbody>

            </table>

            {modalOpen && (

                <TimeModal

                    time={
                        selectedTime
                    }

                    onClose={() =>
                        setModalOpen(
                            false
                        )
                    }

                    onSave={
                        handleSave
                    }

                />

            )}

        </AdminLayout>

    );
}
